import { hseSetupIssues, normalizeHseSetupStatus } from "../hse/hseCompanySettingsUtils";

export function hseKsSetupIssues(settingsOrSetup, options = {}) {
  if (settingsOrSetup == null) return [];
  if (typeof settingsOrSetup !== "object") return [];
  return hseSetupIssues(settingsOrSetup, options);
}

export function hseKsSetupStatus(settingsOrSetup) {
  if (settingsOrSetup == null || typeof settingsOrSetup !== "object") {
    return normalizeHseSetupStatus({});
  }
  return normalizeHseSetupStatus(settingsOrSetup);
}
